import React from 'react';
import { ConfirmationModal, Title } from '@zen-common/components-base';

export default function ConfirmDeletingStorageModal({ hide, onConfirm }) {
  return (
    <ConfirmationModal
      dismissOnClickOutside
      onCancel={hide}
      onConfirm={onConfirm}
      title={<Title>Confirm deleting storage</Title>}
    >
      Deleting Zendex storage will erase the orderbook data only.
      <br />
      The storage will be wiped and refreshed with updated data, it might take a while.
      <br />
      Deleting storage will not erase your wallet Seed Phrase.
    </ConfirmationModal>
  );
}
